// T020: Create localStorage service for auth persistence

const AUTH_KEY = 'fast-steemit-auth'
const PREFS_KEY = 'fast-steemit-prefs'

export interface StoredAuth {
  username: string
  postingKey: string
  lastLogin: Date
  rcCached: {
    percentage: number
    cachedAt: Date
  }
}

export interface StoredPreferences {
  theme: 'light' | 'dark' | 'system'
  locale: string
  feedRefreshInterval: number
  defaultBodyLength: number
  compactMode: boolean
}

interface MinimalUser {
  username: string
  postingKey: string
  rcPercentage: number
}

export const authStorage = {
  saveAuth(user: MinimalUser): void {
    const stored: StoredAuth = {
      username: user.username,
      postingKey: user.postingKey || '',
      lastLogin: new Date(),
      rcCached: {
        percentage: user.rcPercentage,
        cachedAt: new Date(),
      },
    }
    localStorage.setItem(AUTH_KEY, JSON.stringify(stored))
  },

  loadAuth(): StoredAuth | null {
    const data = localStorage.getItem(AUTH_KEY)
    if (!data) return null

    try {
      const parsed = JSON.parse(data)
      // Convert date strings back to Date objects
      return {
        ...parsed,
        lastLogin: new Date(parsed.lastLogin),
        rcCached: {
          ...parsed.rcCached,
          cachedAt: new Date(parsed.rcCached.cachedAt),
        },
      }
    } catch {
      return null
    }
  },

  clearAuth(): void {
    localStorage.removeItem(AUTH_KEY)
  },

  savePreferences(prefs: Partial<StoredPreferences>): void {
    const current = this.loadPreferences()
    const updated = { ...current, ...prefs }
    localStorage.setItem(PREFS_KEY, JSON.stringify(updated))
  },

  loadPreferences(): StoredPreferences {
    const data = localStorage.getItem(PREFS_KEY)
    if (!data) {
      return {
        theme: 'system',
        locale: 'en',
        feedRefreshInterval: 30,
        defaultBodyLength: 250,
        compactMode: false,
      }
    }

    try {
      return JSON.parse(data)
    } catch {
      return {
        theme: 'system',
        locale: 'en',
        feedRefreshInterval: 30,
        defaultBodyLength: 250,
        compactMode: false,
      }
    }
  },
}
